import { render, staticRenderFns } from "./ActivityLogs.vue?vue&type=template&id=60045577"
import script from "./ActivityLogs.vue?vue&type=script&lang=ts"
export * from "./ActivityLogs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports